export default "__VITE_ASSET__b72a302d__"